import React from 'react'

import HintPopover from "../../../../hint-popover/hint-popover"
import ProjectSession from "../../../../../model2/project/project-session"

import {ItemDisplay} from "../../../../../model2/item/@type";

type Props = {
    canBeSelected           : boolean
    isSelected              : boolean
    isExpanded              : boolean

    onSelect                : callback
    onMenuItemHandleClick?  : callback
}

type State = {
    useHint: boolean,
    hovered: boolean,
}

// const debug = "ProjectTree_ProjectsSection"
const debug = false

export default class ProjectTree_ProjectsSection extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            useHint: false,
            hovered: false
        }
    }

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if (!this.props.canBeSelected) {
            this.onArrowClick(e)
            return
        }

        this.props.onSelect(null)
    }

    onArrowClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        this.props.onMenuItemHandleClick?.(null)
    }

    render() {
        debug && console.log(debug, 'render')

        const classes = Classes('item project', 'level-0', {
            'selected'  : this.props.isSelected,
            'hovered'   : this.state.hovered,
            'disabled'  : !this.props.canBeSelected
        })

        const showArrow = _.some(gd.spaces.projects.rootProjects, (projectSession: ProjectSession) => {
            return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(projectSession.treeDisplay)
        })

        const arrowClasses = Classes("arrow", {
            "hidden"    : !showArrow,
            "closed"    : !this.props.isExpanded,
            "open"      : this.props.isExpanded
        })

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="row">
                    <div className={arrowClasses} onClick={this.onArrowClick}/>
                    <div className="icon ii5-project"/>
                    <div className="name">{gd.spaces.projects.title}</div>
                </div>

                {this.state.useHint &&
                    <HintPopover parent={this} hint={gd.spaces.projects.title} multiline={true}/>}
            </div>
        )
    }
}
